// extracted by mini-css-extract-plugin
export default {"buttonContainer":"HistoryControls_buttonContainer__0c81u"};